import { ReactComponent as HomeIcon } from '../../../Asset/sidenavIcons/home.svg';
import { ReactComponent as Academics } from '../../../Assets/Academics.svg';
import { ReactComponent as Goals } from '../../../Assets/Goals.svg';
import { ReactComponent as AcademicsActive } from '../../../Assets/VectorActive.svg';
import { ReactComponent as GoalsActive } from '../../../Assets/GroupActive.svg';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { Analytics } from '@mui/icons-material';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import ArticleIcon from '@mui/icons-material/Article';
import HomeOutlinedIcon from '@mui/icons-material/Home';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import LogoutIcon from '@mui/icons-material/Logout';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getUserDetails } from '../../../storageService';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({
  handleListClick,
}) => {
  console.log('getUserDetails:', getUserDetails());
  const userDetails = getUserDetails();
  const userType = userDetails?.Type;
  const classes = useStyles();
  const { pathname } = useLocation();
  const decodedPathname = decodeURIComponent(pathname);
  const getFirstPath = decodedPathname.split('/').filter((items: string) => {
    return items && items !== '';
  });
  
  const isMyStudentsActive = pathname.includes('/My%20Students%20Faculty') || 
                             pathname.includes('/My Students Faculty') ||
                             decodedPathname.includes('/My Students Faculty');

  const is1980 = useMediaQuery('(max-width:1280px)');

  // Define all possible tabs
  const allTabs = [
    {
      icon: (isActive: boolean) => (
        <HomeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => (
        isActive ? <AcademicsActive className={classes.listItemIconActive} /> : <Academics className={classes.listItemIcon} />
      ),
      label: 'Academics',
      link: routes.academics,
      name: 'academics',
    },
    {
      icon: (isActive: boolean) => (
        isActive ? <GoalsActive className={classes.listItemIconActive} /> : <Goals className={classes.listItemIcon} />
      ),
      label: 'Goals',
      link: routes.goals,
      name: 'goals',
    },
    {
      icon: (isActive: boolean) => (
        <HowToRegOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Attendance',
      link: routes.attendance,
      name: 'attendance',
    },
    {
      icon: (isActive: boolean) => (
        <PeopleOutlineOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Students',
      link: routes.myStudentsFaculty,
      name: 'myStudents',
    },
    {
      icon: (isActive: boolean) => (
        <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => (
        <AccountCircleIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Profile',
      link: routes.MyStudentProfile,
      name: 'myProfile',
    },
    {
      icon: (isActive: boolean) => (
        <ArticleIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'My Classes',
      link: routes.myClasses,
      name: 'my-classes',
    },
    {
      icon: (isActive: boolean) => (
        <LogoutIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />
      ),
      label: 'Logout',
      link: routes.login,
      name: 'logout',
    },
  ];

  // Filter tabs based on user type
  let sideNavContents = allTabs;
  if (userType === 'Student') {
    const studentTabNames = ['home', 'attendance', 'my-classes', 'goals', 'events', 'logout'];
    sideNavContents = studentTabNames
      .map(tabName => allTabs.find(tab => tab.name === tabName))
      .filter((tab): tab is typeof allTabs[number] => tab !== undefined);
  } else if (userType === 'Faculty') {
    // Only show: Home, Academics, Goals, Attendance, My Students, Events, Logout (in this order)
    const facultyTabNames = ['home', 'academics', 'goals', 'attendance', 'myStudents', 'events', 'logout'];
    sideNavContents = allTabs.filter(tab => facultyTabNames.includes(tab.name));
  }


  return (
    <>
      {is1980 ? (
        <div
          style={{
            overflow: 'auto',
            height: is1980 ? `calc(100vh - 220px)` : `calc(100vh - 270px)`,
          }}
          className="scrollbar-cusgray"
        >
          {sideNavContents?.map((items, index) => {
            const isActive = items.name === 'myStudents' 
              ? isMyStudentsActive 
              : getFirstPath[0] === items.name;
            return (
              <ListItemButton
                onClick={() => {
                  handleListClick(items.link, index);
                }}
                style={{
                  marginTop: '1px',
                }}
                className={`${classes.listItemButton} ${isActive && classes.listItemButtonActive
                  }`}
              >
                <ListItemIcon
                  sx={{
                    minWidth: { xs: '10px', lg: '30px' },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  {items.icon(isActive)}
                </ListItemIcon>
                <ListItemText
                  className={`${classes.listItemText} ${isActive && classes.listItemTextActive
                    }`}
                  sx={{
                    display: {
                      xs: 'none',
                      sm: 'none',
                      md: 'none',
                      lg: 'block',
                    },
                  }}
                >
                  {items.label}
                </ListItemText>
              </ListItemButton>
            );
          })}
        </div>
      ) : (
        <>
          <div
            style={{ overflow: 'auto', height: 'calc(100vh - 260px)' }}
            className="scrollbar-cusgray"
          >
            {sideNavContents?.slice(0, -1)?.map((items, index) => {
              const isActive = items.name === 'myStudents' 
                ? isMyStudentsActive 
                : getFirstPath[0] === items.name;
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '1px',
                  }}
                  className={`${classes.listItemButton} ${isActive &&
                    classes.listItemButtonActive
                    }`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                    {items.icon(isActive)}
                  </ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${isActive &&
                      classes.listItemTextActive
                      }`}
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'block',
                      },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
          <div>
            {sideNavContents.slice(-1)?.map((items, index) => {
              const isActive = items.name === 'myStudents' 
                ? isMyStudentsActive 
                : getFirstPath[0] === items.name;
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '0px',
                    position: 'absolute',
                    bottom: '0px',
                    marginBottom: '64px',
                  }}
                  className={`${classes.listItemButton} ${isActive &&
                    classes.listItemButtonActive
                    }`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>
                    {items.icon(isActive)}
                  </ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${isActive &&
                      classes.listItemTextActive
                      }`}
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'none',
                        md: 'none',
                        lg: 'block',
                      },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default SideNavTabs;
